import React from 'react';
import { bool, shape, string } from 'prop-types';

const VideoGuides = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.125 5.625V12.375L12.375 9L7.125 5.625Z" fill="currentColor" />
    <path d="M15 3H3C2.175 3 1.5 3.675 1.5 4.5V13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V4.5C16.5 3.675 15.825 3 15 3ZM15 13.5075H3V4.4925H15V13.5075Z" fill="currentColor" />
  </svg>
);

VideoGuides.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default VideoGuides;
